// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WGs4z","content":"styles_content__3fpoS","row":"styles_row__1C8GW","footer":"styles_footer__1-uOd","phraseLength":"styles_phraseLength__1AI5Q"};